export enum EmailThreadStatus {
  Active = 'ACTIVE',
  Blocked = 'BLOCKED',
}

export interface Email {
  emailThreadId: number;
  externalThreadId: string;
  emailId: string;
  accountId: number;
  userId: number;
  subject: string;
  emailMessageLLMBody: string | null;
  companyId: number;
  fields: any | null;
  fieldMeta: any | null;
  externalIntegrationType: string;
  status: EmailThreadStatus | null;
  meta: any | null;
  createdAt: string;
  updatedAt: string;
  emailThreadType: string | null;
  sender: string;
  latestMessagePreview?: string | null;
  latestMessageTimestamp?: string | null;
}

export interface PaginatedEmailsResponse {
  count: number;
  emailThreads: Email[];
  lastRecordPointer: number;
}
